import React from 'react'
import styled from '@emotion/styled'

const Wrapper = styled.section`
  margin: 0 auto auto;
  width: 100%;
  max-width: ${props => props.theme.sizes.maxWidth};
  @media screen and (max-width: ${props => props.theme.responsive.medium}) {
    padding: 1.5em 1em 2em;
  }
  padding: 1.5em 2.5em 2em;
  flex-grow: 1;
`

const Container = props => {
  return <Wrapper>{props.children}</Wrapper>
}

export default Container
